<template>
  <b-modal
    id="modal-remove-user"
    no-close-on-backdrop
    centered
    hide-footer
    hide-header
    body-class="modal-remove-user"
    content-class="modal-remove-user"
  >
    <template #default>
      <b-container fluid>
        <b-row class="justify-content-center mt-2">
          <b-col cols="auto">
            <b-icon
              icon="x-circle-fill"
              style="color: #d85a4a; width: 50px; height: 50px"
            ></b-icon>
          </b-col>
        </b-row>
        <b-row class="justify-content-center mt-3">
          <b-col cols="6">
            <p class="text1-modal-remove-user confirm-user">
              Tem certeza que deseja excluir?
            </p>
          </b-col>
        </b-row>
        <b-row class="justify-content-center mb-5 mt-3">
          <b-col cols="6">
            <p class="text2-modal-remove-user">
              Após a confirmação não será <br />
              possível recuperar
            </p>
          </b-col>
        </b-row>
        <b-row class="justify-content-center mb-3">
          <b-col cols="auto">
            <button
              class="button-modal-remove-user btn-one"
              @click="$bvModal.hide('modal-remove-user')"
            >
              <span>NÃO</span>
            </button>
          </b-col>
        </b-row>
        <b-row class="justify-content-center mb-2">
          <b-col cols="auto">
            <button
              class="button-modal-remove-user btn-two"
              type="button"
              @click="responseModal()"
            >
              <span>SIM</span>
            </button>
          </b-col>
        </b-row>
      </b-container>
    </template>
  </b-modal>
</template>

<script>
export default {
  methods: {
    responseModal() {
      this.$emit('responseModalRemoveUser');
    },
  },
};
</script>

<style>
.modal-remove-user {
  background-color: #e8e8e8;
  padding: 8px;
  border-radius: 12px;
  border: none;
}

.text1-modal-remove-user,
.text2-modal-remove-user,
.button-modal-remove-user {
  font-family: 'Inter', sans-serif;
  font-style: normal;
}

.text1-modal-remove-user,
.text2-modal-remove-user {
  text-align: center;
}

.text1-modal-remove-user {
  font-size: 24px;
  font-weight: 900;
  color: #d85a4a;
}

.text2-modal-remove-user {
  font-weight: 300;
  font-size: 16px;
  color: black;
}

.button-modal-remove-user {
  min-width: fit-content;
  width: 196px;
  height: 28px;
  font-size: 12px;
  line-height: 12px;
  letter-spacing: 0.35em;
  font-weight: 700;
  border-radius: 13px;
}

.button-modal-remove-user:focus {
  outline: none;
}

.button-modal-remove-user.btn-one {
  color: #272727;
  border: 1px solid #272727;
  background-color: transparent;
}

.button-modal-remove-user.btn-two {
  color: white;
  border: none;
  background-color: #d85a4a;
}
</style>
